<div  class="progresss">
  <div *ngFor="let step of steps; let i = index"  [ngClass]="{'activeStep': i === activeIndex, 'doneStep': i < activeIndex, 'inactiveStep': i > activeIndex}">
    <div style="display: flex;gap: 12px;" >
    <div [ngClass]="{'activeCircle': i === activeIndex, 'doneCircle': i < activeIndex, 'inactiveCircle': i > activeIndex}" >
     <p [ngClass]="{'activeNumber': i === activeIndex, 'doneNumber': i < activeIndex, 'inactiveNumber': i > activeIndex}"  > {{step.number}}</p>
    </div>
    <div class="activeBorder" ></div>
    <div class="textArEn">
      <p [ngClass]="{'activeText': i === activeIndex, 'doneText': i < activeIndex, 'inactiveText': i > activeIndex}"  >{{step.text}}</p>
      <p [ngClass]="{'activeText': i === activeIndex, 'doneText': i < activeIndex, 'inactiveText': i > activeIndex}" >{{step.textAr}}</p>
    </div>
   </div>
    <img *ngIf="i>activeIndex" style="z-index: 10000;align-self: baseline;" src="../../../assets/images/logoArrow.svg" alt=""/>



    </div>
  </div>

